import { combineReducers } from 'redux';
import Header from './components/Header';
import notificationReducers from "./reducers/notificationReducers";

const reducers = combineReducers({
    notification:notificationReducers,
  });
  
const components = { Header };

export { components , reducers };